import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";



// ***********************TIPO TRABAJO*************************

// OBTENER TODOS LOS TIPO TRABAJO
export const getTipoTrabajo = async () => {
  const respuesta = await PrivateInterceptor(`Mantenimiento/TipoTrabajo`, "GET");
  return respuesta;
};


// GUARDAR TIPO TRABAJO
export const GuardarTipoTrabajo = (datos) => {
  const respuesta = PrivateInterceptor("Mantenimiento/TipoTrabajo/AgregarTipoTrabajo", "POST", {datos});
  return respuesta;
};


// EDITAR TIPO TRABAJO
export const EditarTipoTrabajo = (datos) => {
  const respuesta = PrivateInterceptor("Mantenimiento/TipoTrabajo/EditarTipoTrabajo", "POST", {datos});
  return respuesta;
};


// ***********************TIPO PARO*************************

// OBTENER TODOS LOS TIPO PARO
export const getTipoParo = async () => {
  const respuesta = await PrivateInterceptor(`Mantenimiento/TipoParo`, "GET");
  return respuesta;
};

// GUARDAR TIPO TRABAJO
export const GuardarTipoParo = (datos) => {
  const respuesta = PrivateInterceptor("Mantenimiento/TipoParo/AgregarTipoParo", "POST", {datos});
  return respuesta;
};


// EDITAR TIPO TRABAJO
export const EditarTipoParo = (datos) => {
  const respuesta = PrivateInterceptor("Mantenimiento/TipoParo/EditarTipoParo", "POST", {datos});
  return respuesta;
};

// ***********************TIPO MANTENIMIENTO*************************

// OBTENER TODOS LOS TIPO PARO
export const getTipoMantenimiento = async () => {
  const respuesta = await PrivateInterceptor(`Mantenimiento/TipoMantenimiento`, "GET");
  return respuesta;
};

// GUARDAR TIPO TRABAJO
export const GuardarTipoMantenimiento = (datos) => {
  const respuesta = PrivateInterceptor("Mantenimiento/TipoMantenimiento/AgregarTipoMantenimiento", "POST", {datos});
  return respuesta;
};


// EDITAR TIPO TRABAJO
export const EditarTipoMantenimiento = (datos) => {
  const respuesta = PrivateInterceptor("Mantenimiento/TipoMantenimiento/EditarTipoMantenimiento", "POST", {datos});
  return respuesta;
};



